import { render, staticRenderFns } from "./ambient-indicator.vue?vue&type=template&id=648baeff&"
import script from "./ambient-indicator.vue?vue&type=script&lang=ts&"
export * from "./ambient-indicator.vue?vue&type=script&lang=ts&"
import style0 from "./ambient-indicator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports